import { render, staticRenderFns } from "./HintCarousel.vue?vue&type=template&id=b10c3f90&scoped=true&"
import script from "./HintCarousel.vue?vue&type=script&lang=js&"
export * from "./HintCarousel.vue?vue&type=script&lang=js&"
import style0 from "./HintCarousel.vue?vue&type=style&index=0&id=b10c3f90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10c3f90",
  null
  
)

export default component.exports